import laptopImage from './laptop.png';

export const NdaPageImages = {
    laptopImage
}